import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@cmde/shadcn";
import { TrophyIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ErrorCustomersList() {
  const { t } = useTranslation();

  return (
    <Empty className="border border-solid bg-white/30">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <TrophyIcon />
        </EmptyMedia>
        <EmptyTitle>{t("customers.list.messages.error_title")}</EmptyTitle>
        <EmptyDescription>
          {t("customers.list.messages.error_description")}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent />
    </Empty>
  );
}
